export default "__VITE_ASSET__VsiqUV$T__"